import React from "react";

import { Button, Card, CardBody, Container, Stack, List } from "@chakra-ui/react";

import { Link, Outlet } from "react-router-dom";

function AdminHomePage({ user }) {
  return (
    <Container maxW={"none"} width={"full"} p={{ base: 2, md: 4 }}>
      <Container maxW={"none"} width={"full"} height={"full"}>
        <Stack direction={{ base: "column", md: "row" }} spacing={{ base: 4, md: 6 }} height={"full"}>
          <Card direction={"column"} width={{ base: "full", md: "20%" }} height={{ base: "auto", md: "100%" }} borderRadius={"5px"}>
            <CardBody>
              <Stack spacing={4}>
                <List spacing={3}>
                  <Button
                    as={Link}
                    to="/admin/users"
                    display={"flex"}
                    justifyContent={"left"}
                    width={"full"}
                    colorScheme={"transparent"}
                    color={"black"}
                    _hover={{ outline: "solid 1px" }}
                    size={{ base: "sm", md: "md" }}
                    borderRadius={"5px"}
                  >
                    Collaborateurs
                  </Button>
                  {/* Autres boutons avec les mêmes propriétés responsives */}
                  <Button
                    as={Link}
                    to="/admin/clients"
                    display={"flex"}
                    justifyContent={"left"}
                    width={"full"}
                    colorScheme={"transparent"}
                    color={"black"}
                    _hover={{ outline: "solid 1px" }}
                    size={{ base: "sm", md: "md" }}
                    borderRadius={"5px"}
                  >
                    Clients
                  </Button>
                  <Button
                    as={Link}
                    to="/admin/brands"
                    display={"flex"}
                    justifyContent={"left"}
                    width={"full"}
                    colorScheme={"transparent"}
                    color={"black"}
                    _hover={{ outline: "solid 1px" }}
                    size={{ base: "sm", md: "md" }}
                    borderRadius={"5px"}
                  >
                    Marques
                  </Button>
                  <Button
                    as={Link}
                    to="/admin/projects"
                    display={"flex"}
                    justifyContent={"left"}
                    width={"full"}
                    colorScheme={"transparent"}
                    color={"black"}
                    _hover={{ outline: "solid 1px" }}
                    size={{ base: "sm", md: "md" }}
                    borderRadius={"5px"}
                  >
                    Sections
                  </Button>
                  <Button
                    as={Link}
                    to="/admin/tasks"
                    display={"flex"}
                    justifyContent={"left"}
                    width={"full"}
                    colorScheme={"transparent"}
                    color={"black"}
                    _hover={{ outline: "solid 1px" }}
                    size={{ base: "sm", md: "md" }}
                    borderRadius={"5px"}
                  >
                    Tâches
                  </Button>
                  <Button
                    as={Link}
                    to="/admin/settings"
                    display={"flex"}
                    justifyContent={"left"}
                    width={"full"}
                    colorScheme={"transparent"}
                    color={"black"}
                    _hover={{ outline: "solid 1px" }}
                    size={{ base: "sm", md: "md" }}
                    borderRadius={"5px"}
                  >
                    Paramètres
                  </Button>
                </List>
              </Stack>
            </CardBody>
          </Card>
          <Card direction={"column"} width={{ base: "full", md: "80%" }} height={"100%"} borderRadius={"5px"} display={"flex"} alignItems={"left"} py={{ base: 3, md: 6 }}>
            <CardBody width={"full"} display={"flex"} justifyContent={"center"} px={{ base: 2, md: 4 }}>
              <Outlet />
            </CardBody>
          </Card>
        </Stack>
      </Container>
    </Container>
  );
}

export default AdminHomePage;
